import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingDonateButton from "./components/FloatingDonateButton";
import FloatingWhatsAppButton from "./components/FloatingWhatsAppButton";
import Home from "./pages/Home";
import About from "./pages/About";
import OurWork from "./pages/OurWork";
import Adopt from "./pages/Adopt";
import Donate from "./pages/Donate";
import Volunteer from "./pages/Volunteer";
import PawsitiveProtectors from "./pages/PawsitiveProtectors";
import EmergencyRescue from "./pages/EmergencyRescue";
import Newsletter from "./pages/Newsletter";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/adopt" element={<Adopt />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/volunteer" element={<Volunteer />} />
          <Route path="/pawsitive-protectors" element={<PawsitiveProtectors />} />
          <Route path="/emergency" element={<EmergencyRescue />} />
          <Route path="/blog" element={<Newsletter />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <FloatingWhatsAppButton />
        <FloatingDonateButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
